<template>
  <router-link-modified v-if="vacancy.sended"
                        :to="{
                            query: {
                              currentTab: 0
                            }}"
                        class="vacancy-item__respond">
    <span>{{ $tMyVacancy('My responds') }}</span>
    <BaseSvg name="ico-arrow-light"/>
  </router-link-modified>

  <button v-else-if="isDisabled"
          @click.prevent="subscribeOnVacancy"
          class="vacancy-item__respond">
    <span>{{ $tMyVacancy('Report about new vacancies') }}</span>
  </button>

  <button v-else
          @click.prevent="onRespond"
          class="vacancy-item__respond">
    <span>{{ $tMyVacancy('To respond') }}</span>
    <BasePreloader v-if="pendingRespond"
                   class="_small"/>
  </button>
</template>

<script>
  import parseDate from '@/helpers/parseDate'
  import respondOnVacancy from '@/actions/respondOnVacancy'

  export default {
    name: 'AccountMyVacanciesItemMainActionsRespond',
    props: {
      vacancy: Object
    },
    data() {
      return {
        pendingRespond: false
      }
    },
    computed: {
      isDisabled() {
        if (!this.vacancy[1].relevant) return true // ?
        if (!this.vacancy[1].quantity) return true

        const relevantDate = parseDate(this.vacancy[1].relevant)
        return new Date() > relevantDate //ok
      },
    },
    methods: {
      onRespond() {
        this.pendingRespond = true

        respondOnVacancy(this.vacancy.ID, true)
          .then(() => {
            this.$emit('responded')
          })
          .finally(() => {
            this.pendingRespond = false
          })
      },
      subscribeOnVacancy() {
        this.$vModal.open('subscribe-on-vacancy', {
          vacancyId: this.vacancy.ID
        })
      },
    }
  }
</script>

<style lang="less">

</style>
